export default __webpack_public_path__ + "static/media/workflow_almost_missed.b6c3c94b.svg";